document.getElementById('generalShareBtn').addEventListener('click', function() {
    // Create a URL object
    const url = new URL(window.location.href);

    // Set or update the UTM parameter
    url.searchParams.set('utm_source', 'share_sheet');

    // Check if the Web Share API is supported
    if (navigator.share) {
      navigator.share({
        title: document.title,  // you can customize this
        text: 'Check out this awesome product!', // you can customize this
        url: url.toString(),
      })
      .then(() => console.log('Successful share'))
      .catch((error) => console.log('Error sharing:', error));
    } else {
      // If Web Share API is not supported, fallback to copying the link to the clipboard
      copyToClipboard(url.toString());
    }
});
  
  function copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    
    const shareButton = document.getElementById('generalShareBtn');
    shareButton.textContent = "Link copied!";
    
    // Optionally, revert the text back to "Share" after a few seconds
    setTimeout(() => {
      shareButton.textContent = "Share";
    }, 5000); // change back after 3 seconds
  }